import React, { Component } from 'react';
import moment from 'moment';
import Gmaps from '../common/Gmaps';
import DriverEmergencyDisplayOnMap from '../DriverEmergency/DriverEmergencyDisplayOnMap';
import { imageBasePath } from '../../constants/staticData';


export default class DriverDetails extends Component {
  constructor(props) {
    super(props);
    this.state={mapAddress : ''}
    this.getCurrentLocationFromLatLng = this.getCurrentLocationFromLatLng.bind(this);
    this.updateDatalat = this.updateDatalat.bind(this);
  }

  componentWillReceiveProps(nextProps) {

  }

  componentWillMount() {
    let latlongInfo = this.props.requestDetails.garagejobquote.emergencyjobdetails[0];
    console.log(latlongInfo);
    console.log(this.props.requestDetails.garagejobquote);
    this.getCurrentLocationFromLatLng(latlongInfo);
    this.setState({driverLatInfo : latlongInfo.latitude, driverLngInfo :latlongInfo.longitude })
  }
  componentDidMount() {
    let that = this;
    window.socket.on('Driver Location', function (data) {
    that.updateDatalat(data); });
  }

  updateDatalat(data) {
    this.setState({ driverLatInfo: data.location.lat,
    driverLngInfo : data.location.lng });
  }

  getCurrentLocationFromLatLng(latlng){
    const that = this;
    let geocoder = new google.maps.Geocoder();
    geocoder.geocode({location: {'lat' : Number(latlng.latitude), 'lng': Number(latlng.longitude)}}, (results, status) => {
      if (status == google.maps.GeocoderStatus.OK && results && results.length) {
           that.updateData(results[0].formatted_address);
      }
    });
  }

  updateData(dataresult){
     this.setState({mapAddress:dataresult});
   }






  render() {
    const {
      requestDetails

    } = this.props;
    let DriverInfo = requestDetails.garagejobquote.emergencyjobdetails[0];
    return (
      <div className="quotesSection-view">
          <div className={(requestDetails.jobStatus == 'in progress') ?'quotes-dateTime-holder row':'driverSection-body quotes-dateTime-holder row'}>
            <div className={  requestDetails.jobStatus == 'in progress' ?'':'jobDetails-content'}>
              <div className="jobDetails-container">
              {  (requestDetails.jobStatus == 'in progress' || requestDetails.jobStatus == 'confirmed')? <div>
                <Gmaps
                    center={{
                          lat: Number(requestDetails.latitude),
                          lng: Number(requestDetails.longitude)
                         }}
                  zoom={9}
                   marker={{ "position": { lat: Number(requestDetails.latitude), lng: Number(requestDetails.longitude) } }}
                   pinImage={`${imageBasePath}/drag-loc.png`}
                   currentmarker={{ "position": { lat: Number(this.state.driverLatInfo), lng: Number(this.state.driverLngInfo) } }}
                   currentImage={`${imageBasePath}/map_blue_pointer.png`}

                   containerElement={<div style={{ height: "auto", width: 100 + '%' }} />}
                   mapElement={<div style={{ height: (window.screen.availHeight-300) + 'px', width: 100 + '%' }} />


                   }/>

<DriverEmergencyDisplayOnMap {...this.props}  flowType='businessDriverTrack'/>

              </div> :<div>
               <div className="desc-block width-50 driver-content-adjust">
                 <h5>USER NAME </h5>
                 <span className="text-ellipsis">{DriverInfo.driverName}</span>
               </div>
               <div className="desc-block width-50 driver-content-adjust">
                 <h5>MOBILE NUMBER </h5>
                 <span className="text-ellipsis">{DriverInfo.driverPhone}</span>
               </div>
               <div className="desc-block width-50 driver-content-adjust">
                 <h5>LOCATION </h5>
                 <span className="text-ellipsis">{this.state.mapAddress}</span>
               </div>
               <div className="desc-block width-50 driver-content-adjust">
                 <h5>VEHICLE TYPE </h5>
                 <span className="text-ellipsis">{DriverInfo.vehicleType}</span>
               </div>
               <div className="desc-block width-50 driver-content-adjust">
                 <h5>JOB QUEUE </h5>
                 <span className="text-ellipsis">{DriverInfo.jobqueue}</span>
               </div>
               <div className="desc-block width-50 driver-content-adjust">
                 <h5>STATUS </h5>
                 <span className="text-ellipsis">{DriverInfo.vehicleStatus}</span>
               </div>
              </div> }


              </div>
            </div>
          </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/JobDetailsView/DriverDetails.jsx